import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaAngleRight, FaUserFriends, FaWallet } from "react-icons/fa";
import { FiLogOut, FiSettings } from "react-icons/fi";
import { MdDashboard } from "react-icons/md";
import { HiOutlineMenu, HiMenu } from "react-icons/hi";

const SideNavBar = ({
  setOpenPage,
  isCollapsed,
  toggleSidebar,
  setIsCollapsed,
}) => {
  const navigate = useNavigate();
  const [active, setActive] = useState("");
  const [openMenu, setOpenMenu] = useState(null);
  const menuSectionRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  const UserName = localStorage.getItem("UserName");
  const UserAvatar = localStorage.getItem("UserAvatar");
  const userRole = localStorage.getItem("UserRole");

  useEffect(() => {
    const handleMouseEnter = () => {
      if (isCollapsed) {
        setIsHovered(true);
        setIsCollapsed(false);
      }
    };

    const handleMouseLeave = () => {
      if (isHovered) {
        setIsHovered(false);
        setIsCollapsed(true);
      }
    };

    const menuSection = menuSectionRef.current;
    if (menuSection) {
      menuSection.addEventListener("mouseenter", handleMouseEnter);
      menuSection.addEventListener("mouseleave", handleMouseLeave);
    }

    return () => {
      if (menuSection) {
        menuSection.removeEventListener("mouseenter", handleMouseEnter);
        menuSection.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
  }, [isCollapsed, isHovered, setIsCollapsed]);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    navigate("/login");
  };

  return (
    <div
      className={`fixed top-0 left-0 bg-gray-900 h-screen flex flex-col transition-all duration-300 z-50 ${
        isCollapsed && !isHovered ? "w-[3.6rem]" : "w-[13.9rem]"
      }`}
    >
      {/* Header */}
      <div
        className={`px-2 border-b py-3 border-gray-700 flex ${
          isCollapsed && !isHovered ? "justify-center" : "justify-between"
        } items-center`}
      >
        {(!isCollapsed || isHovered) && (
          <div className="flex items-center gap-4">
            <img
              src={UserAvatar || "https://pa-app.serverscripts.in/public/images/user.png"}
              className="w-9 h-9 rounded-full"
              alt="Profile"
            />
            <p className="text-white">
              {UserName || "Soumitra Halder"}
            </p>
          </div>
        )}

        <button
          onClick={toggleSidebar}
          className="text-white p-2 rounded-md hover:bg-gray-700"
        >
          {isCollapsed && !isHovered ? (
            <HiMenu className="text-2xl" />
          ) : (
            <HiOutlineMenu className="text-2xl" />
          )}
        </button>
      </div>

      {/* Menu */}
      <div
        ref={menuSectionRef}
        className="flex flex-col p-2 text-white overflow-y-auto h-[83vh]"
      >
        {/* Dashboard */}
        <Link
          to="/dashboard"
          onClick={() => {
            /* if (setOpenPage) setOpenPage("dashboard"); */
            setOpenMenu(openMenu === "dashboard" ? null : "dashboard");
          }}
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 mb-2 rounded ${
            active === "dashboard" ? "bg-blue-800" : "bg-gray-800"
          }`}
        >
          <div className="flex items-center gap-3">
            <MdDashboard className="text-xl" />
            {(!isCollapsed || isHovered) && <p>Dashboard</p>}
          </div>
        </Link>

        {/* SCHOOL */}
        <div>
          <div
            onClick={() =>
              setOpenMenu(openMenu === "school" ? null : "school")
            }
            className="flex items-center justify-between p-2 mb-2 bg-gray-800 rounded cursor-pointer"
          >
            <div className="flex items-center gap-3">
              <FaUserFriends />
              {(!isCollapsed || isHovered) && <p>School</p>}
            </div>
            <FaAngleRight
              className={`${openMenu === "school" ? "rotate-90" : ""}`}
            />
          </div>

          {openMenu === "school" && (
            <div>
              <Link to="/view-school" className="block pl-6 p-2 bg-gray-700 mb-1 rounded">
                School Lists
              </Link>
              <Link to="/view-in-active-school" className="block pl-6 p-2 bg-gray-700 mb-1 rounded">
                Inactive Schools
              </Link>
            </div>
          )}
        </div>

      {Number(userRole) === 1 && (
        <div>
          <div
            onClick={() =>
              setOpenMenu(openMenu === "staffs" ? null : "staffs")
            }
            className="flex items-center justify-between p-2 mb-2 bg-gray-800 rounded cursor-pointer"
          >
            <div className="flex items-center gap-3">
              <FaWallet />
              {(!isCollapsed || isHovered) && <p>Staffs</p>}
            </div>
            <FaAngleRight
              className={`${openMenu === "staffs" ? "rotate-90" : ""}`}
            />
          </div>

          {openMenu === "staffs" && (
            <div>
              <Link to="/view-staff" className="block pl-6 p-2 bg-gray-700 mb-1 rounded">
                Staff List
              </Link>
              {/* <Link to="/dashboard" className="block pl-6 p-2 bg-gray-700 mb-1 rounded">
                Add Staff
              </Link> */}
              <Link to="/designation" className="block pl-6 p-2 bg-gray-700 mb-1 rounded">
                Designation
              </Link>
            </div>
          )}
        </div>
      )}

        <div>
          <div
            onClick={() =>
              setOpenMenu(openMenu === "PackageDetails" ? null : "PackageDetails")
            }
            className="flex items-center justify-between p-2 mb-2 bg-gray-800 rounded cursor-pointer"
          >
            <div className="flex items-center gap-3">
              <FiSettings />
              {(!isCollapsed || isHovered) && <p>Package Details</p>}
            </div>
            <FaAngleRight
              className={`${openMenu === "PackageDetails" ? "rotate-90" : ""}`}
            />
          </div>

          {openMenu === "PackageDetails" && (
            <div>
              <Link to="/view-package" className="block pl-6 p-2 bg-gray-700 mb-1 rounded">
                Package Lists
              </Link>
               <Link to="/view-module" className="block pl-6 p-2 bg-gray-700 rounded">
                Module Lists
              </Link> 
            </div>
          )}
        </div>
        <div>
          <div
            onClick={() =>
              setOpenMenu(openMenu === "subscription" ? null : "subscription")
            }
            className="flex items-center justify-between p-2 mb-2 bg-gray-800 rounded cursor-pointer"
          >
            <div className="flex items-center gap-3">
              <FiSettings />
              {(!isCollapsed || isHovered) && <p>Subscription</p>}
            </div>
            <FaAngleRight
              className={`${openMenu === "subscription" ? "rotate-90" : ""}`}
            />
          </div>

          {openMenu === "subscription" && (
            <div>
              <Link to="/view-subscription" className="block pl-6 p-2 bg-gray-700 mb-1 rounded">
                Subscriptions
              </Link>
              {/* <Link to="/dashboard" className="block pl-6 p-2 bg-gray-700 rounded">
                Add Plan
              </Link> */}
            </div>
          )}
        </div>


        {/* FORM DETAILS */}
        <div>
          <div
            onClick={() =>
              setOpenMenu(openMenu === "form" ? null : "form")
            }
            className="flex items-center justify-between p-2 mb-2 bg-gray-800 rounded cursor-pointer"
          >
            <div className="flex items-center gap-3">
              <FiSettings />
              {(!isCollapsed || isHovered) && <p>Form Details</p>}
            </div>
            <FaAngleRight
              className={`${openMenu === "form" ? "rotate-90" : ""}`}
            />
          </div>

          {openMenu === "form" && (
            <div>
              {/* <Link to="/dashboard" className="block pl-6 p-2 bg-gray-700 mb-1 rounded">
                Fill Form
              </Link> */}
              <Link to="/view-form" className="block pl-6 p-2 bg-gray-700 rounded">
                View Form
              </Link>
            </div>
          )}
        </div>
      </div>

      {/* Logout */}
      <div className="mt-auto p-4 border-t border-gray-700">
        <div
          onClick={handleLogout}
          className="flex items-center gap-3 text-white cursor-pointer"
        >
          <FiLogOut />
          {(!isCollapsed || isHovered) && <p>Logout</p>}
        </div>
      </div>
    </div>
  );
};

export default SideNavBar;